import { store } from "../../App";
import { bioGetAccessLevels } from "../../db/BioStar/APIs";

export const getAccessLevels = async () => {
  try {
    const access = await bioGetAccessLevels()

    store.dispatch({ type: "FETCH_ACCESS_V2", data: { access_groups: access.access_groups, doors: access.doors } });

  } catch (e) {

  }

};
